import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-[#1a3a6c] text-white pt-10" data-id="element-28">
      <div className="container mx-auto px-4" data-id="element-29">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-30">
          {/* Company Info */}
          <div data-id="element-31">
            <h3 className="text-xl font-bold mb-4" data-id="element-32">Opticore</h3>
            <p className="mb-4" data-id="element-33">
              Your trusted appliance repair specialists across the UK. We
              provide professional repairs and maintenance services with fixed
              pricing and exceptional customer care.
            </p>
            <div className="flex items-center mb-2" data-id="element-34">
              <MapPinIcon size={16} className="mr-2" data-id="element-35" />
              <p data-id="element-36">113 Church Rd, Birmingham B25 8UX</p>
            </div>
            <div className="flex items-center mb-2" data-id="element-37">
              <PhoneIcon size={16} className="mr-2" data-id="element-38" />
              <p data-id="element-39">0800 055 4969</p>
            </div>
            <div className="flex items-center mb-2" data-id="element-40">
              <MailIcon size={16} className="mr-2" data-id="element-41" />
              <p data-id="element-42">23tata0716@gmail.com</p>
            </div>
          </div>
          {/* Opening Hours */}
          <div data-id="element-43">
            <h3 className="text-xl font-bold mb-4" data-id="element-44">Opening Hours</h3>
            <div className="flex items-start mb-2" data-id="element-45">
              <ClockIcon size={16} className="mr-2 mt-1" data-id="element-46" />
              <div data-id="element-47">
                <p className="mb-1" data-id="element-48">Monday: 9:00am – 5:00pm</p>
                <p className="mb-1" data-id="element-49">Tuesday: 9:00am – 5:00pm</p>
                <p className="mb-1" data-id="element-50">Wednesday: 9:00am – 5:00pm</p>
                <p className="mb-1" data-id="element-51">Thursday: 9:00am – 5:00pm</p>
                <p className="mb-1" data-id="element-52">Friday: 9:00am – 5:00pm</p>
                <p className="mb-1" data-id="element-53">Saturday: Closed</p>
                <p data-id="element-54">Sunday: Closed</p>
              </div>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-55">
            <h3 className="text-xl font-bold mb-4" data-id="element-56">Quick Links</h3>
            <ul className="space-y-2" data-id="element-57">
              <li data-id="element-58">
                <Link to="/" className="hover:text-[#f97316] transition-colors" data-id="element-59">
                  Home
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/service-coverage" className="hover:text-[#f97316] transition-colors" data-id="element-61">
                  Service Coverage
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/about-us" className="hover:text-[#f97316] transition-colors" data-id="element-63">
                  About Us
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/contact-us" className="hover:text-[#f97316] transition-colors" data-id="element-65">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/faq" className="hover:text-[#f97316] transition-colors" data-id="element-67">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>
          {/* Policies and Family Image */}
          <div data-id="element-68">
            <h3 className="text-xl font-bold mb-4" data-id="element-69">Policies</h3>
            <ul className="space-y-2 mb-6" data-id="element-70">
              <li data-id="element-71">
                <Link to="/cancellation-policy" className="hover:text-[#f97316] transition-colors" data-id="element-72">
                  Cancellation Policy
                </Link>
              </li>
              <li data-id="element-73">
                <Link to="/refund-policy" className="hover:text-[#f97316] transition-colors" data-id="element-74">
                  Refund Policy
                </Link>
              </li>
              <li data-id="element-75">
                <Link to="/privacy-policy" className="hover:text-[#f97316] transition-colors" data-id="element-76">
                  Privacy & Cookie Policy
                </Link>
              </li>
              <li data-id="element-77">
                <Link to="/terms-conditions" className="hover:text-[#f97316] transition-colors" data-id="element-78">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
            <div className="mt-4" data-id="element-79">
              <img src="https://images.unsplash.com/photo-1556911220-e15b29be8c8f?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60" alt="Happy family in kitchen" className="rounded-lg w-full h-auto" data-id="element-80" />
            </div>
          </div>
        </div>
        {/* Payment Methods */}
        <div className="mt-8 pt-6 border-t border-[#3b82f6]" data-id="element-81">
          <div className="flex flex-wrap justify-center gap-4 mb-4" data-id="element-82">
            <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/visa.svg" alt="Visa" className="h-8 w-auto bg-white p-1 rounded" data-id="element-83" />
            <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/mastercard.svg" alt="Mastercard" className="h-8 w-auto bg-white p-1 rounded" data-id="element-84" />
            <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/paypal.svg" alt="PayPal" className="h-8 w-auto bg-white p-1 rounded" data-id="element-85" />
            <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/shopify.svg" alt="Shop Pay" className="h-8 w-auto bg-white p-1 rounded" data-id="element-86" />
          </div>
        </div>
        {/* Copyright */}
        <div className="py-4 text-center text-sm border-t border-[#3b82f6]" data-id="element-87">
          <p data-id="element-88">
            &copy; {new Date().getFullYear()} Opticore. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;